import React, { useState, useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import SellerSidebar from './SellerSidebar';
import SellerNavbar from './SellerNavbar';
import { useUser } from '../../context/UserContext';
import '../../pages/seller/seller.css';

const SellerLayout = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { user, isAuthenticated, loading } = useUser();

  // Authentication & Authorization check
  useEffect(() => {
    if (loading) return;
    
    if (!isAuthenticated) {
      navigate('/account');
    } else if (user?.role !== 'seller') {
      navigate('/');
    } else if (user?.sellerStatus !== 'approved') {
      navigate('/seller/application');
    }
  }, [isAuthenticated, user, loading, navigate]);

  // CSS wrapper for scoping
  useEffect(() => {
    document.body.classList.add('seller-mode');
    return () => document.body.classList.remove('seller-mode');
  }, []);

  // Close mobile menu on route change
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  if (loading) {
     return (
        <div className="d-flex justify-content-center align-items-center bg-light" style={{ minHeight: '100vh' }}>
            <div className="spinner-border text-success" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>
     );
  }

  if (!isAuthenticated || user?.role !== 'seller' || user?.sellerStatus !== 'approved') {
    return null; // Will redirect via the useEffect
  }

  return (
    <div className="seller-layout">
      {/* Mobile Sidebar Overlay */}
      <div 
        className={`sidebar-overlay ${mobileMenuOpen ? 'active' : ''}`}
        onClick={() => setMobileMenuOpen(false)}
      ></div>

      <SellerSidebar 
        collapsed={sidebarCollapsed}
        mobileOpen={mobileMenuOpen}
        onToggle={() => setSidebarCollapsed(!sidebarCollapsed)}
      />

      <div className="seller-main bg-light">
        <SellerNavbar 
          onToggleMobile={() => setMobileMenuOpen(true)} 
        />
        <main className="seller-content-wrapper">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default SellerLayout;
